<div class="form-group">
    <label class="input-label">Field tag</label>
    <tag-input [(ngModel)]="fieldOptions.tags"
               [identifyBy]="'id'"
               [displayBy]="'name'"
               (ngModelChange)="dataChangedEvent($event)"
               (onAdd)="onTagAdded($event)"
               theme="bootstrap">
        <tag-input-dropdown [autocompleteItems]="tagItems"
                            [identifyBy]="'id'"
                            [displayBy]="'name'">
        </tag-input-dropdown>
    </tag-input>
</div>